import type {
  FilePagedResult,
  FileDetail,
  FileTagPagedResult,
  FileTag,
} from '~/types/api'
import type { QueryParams } from '~/types/api'
import { APIFilters } from '~/utils/APIFilters'

export function createFilesRepository() {
  const { $api } = useNuxtApp()
  const { get } = baseRepository($api)

  const DOMAIN = 'files'
  const DOMAIN_TAGS = 'file-tags'

  async function getAll(params?: QueryParams) {
    if (!params) {
      params = {
        sort: APIFilters.makeSort({ weight: 'ASC', nid: 'DESC' }),
      }
    }
    return get<FilePagedResult>([DOMAIN], { params })
  }

  async function getAllPagination(
    page: number,
    itemsPerPage: number,
    productLinesNid?: number[],
    textSearch?: string,
    fileTags?: number[]
  ) {
    const filter = []
    filter.push({
      [APIFilterOP.EQUALS]: {
        'fileTags.publicStatus': '1',
      },
    })
    if (textSearch && textSearch !== '') {
      filter.push({
        [APIFilterOP.OR]: [
          {
            [APIFilterOP.LIKE]: {
              fileName: textSearch,
            },
          },
          {
            [APIFilterOP.LIKE]: {
              'fileProductLines.title': textSearch,
            },
          },
          {
            [APIFilterOP.LIKE]: {
              'imageProductLines.title': textSearch,
            },
          },
        ],
      })
    }
    if (fileTags && fileTags.length !== 0) {
      filter.push({
        [APIFilterOP.IN]: {
          'fileTags.translationOfNid': fileTags,
        },
      })
    }
    if (productLinesNid && productLinesNid.length !== 0) {
      filter.push({
        [APIFilterOP.OR]: [
          {
            [APIFilterOP.IN]: {
              'fileProductLines.translationOfNid': productLinesNid,
            },
          },
          {
            [APIFilterOP.IN]: {
              'imageProductLines.translationOfNid': productLinesNid,
            },
          },
        ],
      })
    }
    const params = {
      sort: APIFilters.makeSort({ nid: 'ASC' }),
      filter: APIFilters.makeFilter(filter),
      page: page,
      itemsPerPage: itemsPerPage,
    } as QueryParams

    return get<FilePagedResult>([DOMAIN], { params })
  }

  async function getByNid(nid: number) {
    return get<FileDetail>([DOMAIN, nid])
  }

  async function getAllTags(params?: QueryParams) {
    if (!params) {
      params = {
        sort: APIFilters.makeSort({ weight: 'ASC', title: 'ASC' }),
      }
    }
    return get<FileTagPagedResult>([DOMAIN_TAGS], {
      params,
    })
  }

  async function getTag(nid: number) {
    return get<FileTag>([DOMAIN_TAGS, nid])
  }

  return {
    getAll,
    getAllPagination,
    getByNid,
    getAllTags,
    getTag,
  }
}
